import { ShapeRenderer } from './ShapeRenderer';
import { SHAPE_META } from './shapeMeta';
import type { FluxogramaShape } from '@/types/fluxograma';

interface DragGhostProps {
  shape: FluxogramaShape;
  /** Posição do cursor em coordenadas de tela (clientX/clientY). */
  cursor: { x: number; y: number };
  zoom: number;
}

/**
 * Prévia semi-transparente da forma sendo arrastada da paleta, seguindo o
 * cursor antes de soltar no canvas — dá feedback visual do que vai ser criado
 * e onde, escalado pelo zoom atual do canvas.
 */
export function DragGhost({ shape, cursor, zoom }: DragGhostProps) {
  const meta = SHAPE_META[shape] ?? SHAPE_META.process;
  const w = meta.defaultWidth * zoom;
  const h = meta.defaultHeight * zoom;

  return (
    <div
      className="pointer-events-none fixed z-50 opacity-60"
      style={{ left: cursor.x - w / 2, top: cursor.y - h / 2, width: w, height: h }}
    >
      <ShapeRenderer shape={shape} width={w} height={h} bgColor="#ffffff" borderColor={meta.defaultColor} borderWidth={2} />
    </div>
  );
}
